import React from 'react';
import '../Css/Notfoundpage.css'; // Import CSS file for styling
import Footer from './Footer';
import error404 from '../Components/image/error404.png';

const Notfoundpage = () => {
  return (
     <div className='container-fluid '>
     <div className='row justify-content-start '>
     <div className='col-12' id='setimg'>
     <img src={error404}  alt='errorphtot'/>
     </div>
     </div>
     
     <div className='row'>
     {<Footer/>}
     </div>
     
     
     
     
     </div>
  );
};

export default Notfoundpage;
